function ThreeDot() {
  return (
    <div className="three-dot-loader">
      <div className="dot1"></div>
      <div className="dot2"></div>
      <div className="dot3"></div>
    </div>
  );
}

export default ThreeDot;
